export default function MessagesData () {
    return ( 
        <div className='App'>
            <h1 className="text-center emphTitle">Metro Housing Boston Updates</h1>
            <br></br>
            <h5 className='text-center  whiteFont'>Coming Soon</h5>  
            <hr></hr>
        </div>
    );
}